import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=04778041&"
import script from "./PatientDetail.vue?vue&type=script&lang=ts&"
export * from "./PatientDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports